import React from "react";

interface TableCellProps {
	value: any;
	colIndex: number;
	row: Array<any>;
	isVirtualized?: boolean;
}

/**
 * Shared cell component for both virtualized and non-virtualized table rows
 */
export function TableCell({ value, colIndex, row, isVirtualized }: TableCellProps) {
	const cellContent = (
		<>
			{value}
			{colIndex === 0 && (
				<>
					<div className="data-table__cell-row">
						<div>{row[1] || "-"}</div>
					</div>
					<div className="data-table__cell-row">
						<div>{row[2] || "-"}</div>
						<div>{row[3] || "-"}</div>
					</div>
				</>
			)}
		</>
	);

	if (isVirtualized) {
		return (
			<div className={`data-table__cell ${colIndex === 0 ? "data-table__cell-first" : ""}`}>
				{cellContent}
			</div>
		);
	}

	return <td className={`data-table__cell ${colIndex === 0 ? "data-table__cell-first" : ""}`}>{cellContent}</td>;
}
